<div class="insured-certificates-container">
  <div class="insured-code-rail">
    @let insuredItems = (insuredItems$ | async);
    @let insuredIsLoading = (insuredLoading$ | async);

    <div #railSnap="itemSnappedHeight"
         class="rail-scroller"
         [albertItemSnappedHeight]="insuredItemSize"
    >
      @if (insuredItems && insuredItems.length > 0) {
        <p-virtualscroller
          [itemSize]="insuredItemSize"
          [scrollHeight]="railSnap.scrollHeight()"
          [items]="insuredItems"
          [lazy]="true"
          [loading]="insuredIsLoading ?? false"
          [showLoader]="true"
          [step]="pageSize"
          (onLazyLoad)="onInsuredLazyLoad($event)"
        >
          <ng-template #item
                       let-item
          >
            <div class="insured-code-cell"
                 [attr.data-test]="'insured-code-item-' + item.uuid"
            >
              @if (item) {
                <albert-list-view-insured-code-list-item
                  [item]="item"
                  [selected]="item.uuid === insuredUuid()"
                  (bulkOptionsRequested)="openInsuredBulkOptions($event)"
                  (itemClicked)="closeSidebarDrawer()"
                />
              } @else {
                <p-skeleton class="p-2"
                            height="2.5rem"
                            width="100%"
                />
              }
            </div>
          </ng-template>
        </p-virtualscroller>
      } @else if (insuredIsLoading) {
        <div class="p-2">
          @for (_ of [0, 1, 2, 3]; track _) {
            <p-skeleton class="mb-2"
                        height="2.5rem"
                        width="100%"
            />
          }
        </div>
      }
    </div>
  </div>

  <div class="insured-certificates-panel">
    @let subtitle = optionsSubtitle();
    @if (subtitle !== null) {
      <div animate.enter="options-panel-enter"
           animate.leave="options-panel-leave"
           class="options-panel"
           data-test="certificate-options-panel"
      >
        <div class="options-header">
          <div class="options-heading">
            <span class="options-title">Options</span>
            <span class="options-subtitle">{{ subtitle }}</span>
          </div>
          <button class="options-close"
                  data-test="certificate-options-close"
                  title="Close"
                  type="button"
                  (click)="closeOptions()"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>

        @for (action of optionsActions(); track action.testId) {
          <button class="options-action"
                  type="button"
                  [attr.data-test]="action.testId"
                  [disabled]="action.disabled ?? false"
                  (click)="onOptionsAction(action)"
          >
            {{ action.label }}
          </button>
        }
      </div>
    }

    @let rows = certificateRows();
    @let certificatesLoading = (certificateLoading$ | async);

    @if (rows.length > 0) {
      <div #certificateSnap="itemSnappedHeight"
           class="certificate-list"
           [albertItemSnappedHeight]="certificateItemSize"
      >
        <p-virtualscroller
          [itemSize]="certificateItemSize"
          [scrollHeight]="certificateSnap.scrollHeight()"
          [items]="rows"
          [lazy]="true"
          [loading]="certificatesLoading ?? false"
          [showLoader]="true"
          [step]="pageSize"
          (onLazyLoad)="onCertificateLazyLoad($event)"
        >
          <ng-template #item
                       let-row
          >
            @if (row.kind === 'header') {
              <button class="certificate-subsection-header"
                      title="Select all certificates in this subsection"
                      type="button"
                      [attr.data-test]="'certificate-subsection-' + row.label"
                      [class.selected-entry]="isSubsectionSelected(row.uuids)"
                      (click)="toggleSubsectionSelection(row.uuids)"
              >
                {{ row.label }}
              </button>
            } @else if (row.item) {
              <div class="certificate-cell"
                   [attr.data-test]="'insured-certificate-item-' + row.item.uuid"
              >
                <albert-list-view-insured-certificate-item
                  [item]="row.item"
                  [bulkOptionsEnabled]="multipleSelected()"
                  [optionsDisabled]="multipleSelected()"
                  [selected]="selectedUuids().has(row.item.uuid)"
                  (bulkOptionsRequested)="openBulkOptions()"
                  (itemClicked)="onCertificateClicked()"
                  (optionsRequested)="openCertificateOptions($event)"
                  (toggled)="toggleCertificateSelection($event)"
                />
              </div>
            } @else {
              <div class="certificate-cell">
                <p-skeleton class="p-2"
                            height="2.5rem"
                            width="100%"
                />
              </div>
            }
          </ng-template>
        </p-virtualscroller>
      </div>
    } @else if (certificatesLoading) {
      <div class="p-2">
        @for (_ of [0, 1, 2, 3]; track _) {
          <p-skeleton class="mb-2"
                      height="2.5rem"
                      width="100%"
          />
        }
      </div>
    }
  </div>
</div>
